<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <section class="card  bg-white p-2" style="width: 120%">
      <div class="d-flex align-items-center">
        <div class="">遊客中心</div>
        <div class="col-4">
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="-1">請選擇</option>
            <option v-for="(list, index) in peopleAnalysisScenicArea" :key="index" :value="list.id">{{list.name}}</option>
          </select>
        </div>
        <div>
          <button type="submit" class="btn btn-primary my-1" @click="getAllData">
            送出查詢
          </button>  
        </div>
      </div>
    </section>  

    <div class="row pt-2 equal-cols" style="width: 120%" >
      <div class="col-md-12">
        <section class="card mb-2">
          <header class="card-header bg-info text-white">
            <div class="card-actions"> <a href="#" class="card-action card-action-toggle" data-card-toggle=""></a> </div>
            <h2 class="card-title">人數統計(本日累計)</h2>
          </header>
          <div class="card-body">
            <div class="row  equal-cols">
              <div class="col-lg-3 col-12" v-for="(item, i) in centerPeopleFlow" :key="i">
                <section class="card card-featured-left card-featured-info mb-1 ">
                  <div class="card-body">
                    <div class="widget-summary">
                      <div class="widget-summary-col widget-summary-col-icon">
                        <div class="summary-icon bg-primary"><i class="fa fa-users"></i></div>
                      </div>
                      <div class="widget-summary-col">
                        <div class="summary">
                          <h2 class="title font-weight-bold">{{item.name}}</h2>
                          <div class="info"><strong class="amount">{{centerPeopleFlowData[item.countKey]}}人</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <!-- <div class="col-lg-2 col-6">
                <section class="card card-featured-left card-featured-info mb-1">
                  <div class="card-body">
                    <div class="widget-summary">
                      <div class="widget-summary-col">
                        <div class="summary">
                          <h4 class="title">容流人數管制量</h4>
                          <div class="info"><strong class="amount">3765</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div> -->
            </div>
          </div>
        </section>
      </div>
    </div>

    <div class="row pt-2 equal-cols" style="width: 120%" >
      <div class="col-md-12">
        <section class="card mb-2">
          <header class="card-header bg-info text-white">
            <div class="card-actions"> <a href="#" class="card-action card-action-toggle" data-card-toggle=""></a> </div>
            <h2 class="card-title">性別統計(本日累計)</h2>
          </header>
          <div class="card-body">
            <div class="row  equal-cols">
              <div class="col-lg-3 col-8" v-for="(category, i) in genderCategory" :key="i">
                <section class="card card-featured-left card-featured-info mb-1 ">
                  <div class="card-body">
                    <div class="widget-summary">
                      <div class="widget-summary-col widget-summary-col-icon">
                        <div class="summary-icon bg-primary"><i class="fa fa-male"></i></div>
                      </div>
                      <div class="widget-summary-col">
                        <div class="summary">
                          <h4 class="title">{{category.name}}</h4>
                          <div class="info"><strong class="amount">{{peopleAnalysisData[category.countKey] + '('+peopleAnalysisData[category.ratioKey]+'%)'}}</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <!-- <div class="col-lg-2 col-6">
                <section class="card card-featured-left card-featured-info mb-1">
                  <div class="card-body">
                    <div class="widget-summary">
                      <div class="widget-summary-col">
                        <div class="summary">
                          <h4 class="title2">男性 <span class="float-right"><strong class="amount text-right">654</strong></span></h4>
                          <h4 class="title2">女性 <span class="float-right"><strong class="amount text-right">88</strong></span></h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div> -->
            </div>
          </div>
        </section>
      </div>
    </div>

    <div class="row pt-2 equal-cols" style="width: 120%" >
      <div class="col-md-12">
        <section class="card mb-2">
          <header class="card-header bg-info text-white">
            <div class="card-actions"> <a href="#" class="card-action card-action-toggle" data-card-toggle=""></a> </div>
            <h2 class="card-title">年齡統計(本日累計)</h2>
          </header>
          <div class="card-body">
            <div class="row  equal-cols">
              <div class="col-lg-3 col-12" v-for="(category, i) in ageCategory" :key="i">
                <section class="card card-featured-left card-featured-info mb-1 ">
                  <div class="card-body">
                    <div class="widget-summary">
                      <div class="widget-summary-col widget-summary-col-icon">
                        <div class="summary-icon bg-primary"><i class="fa fa-users"></i></div>
                      </div>
                      <div class="widget-summary-col">
                        <div class="summary">
                          <h4 class="title">{{category.name}}</h4>
                          <div class="info"><strong class="amount">{{peopleAnalysisData[category.ageKey] + '('+peopleAnalysisData[category.ratioKey]+'%)'}}</strong></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              
              <!-- <div class="col-lg-2 col-6">
                <section class="card card-featured-left card-featured-info mb-1">
                  <div class="card-body">
                    <div class="widget-summary">
                      <div class="widget-summary-col">
                        <div class="summary">
                          <h4 class="title2">老 <span class="float-right"><strong class="amount text-right">63</strong></span></h4>
                          <h4 class="title2">中 <span class="float-right"><strong class="amount text-right">67</strong></span></h4>
                          <h4 class="title2">青 <span class="float-right"><strong class="amount text-right">21</strong></span></h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div> -->
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import {mapState, mapGetters} from 'vuex'
import CONST from '../../utils/const'
import Utils from '../../utils/utils'
import { getCountPerHour } from '../../api/elasticSearch/vehicleplateApi'
import MapMap from '../map/index'

export default {
  name: "Home",
  components: {
    apexchart: VueApexCharts,
    MapMap
  },
  data() {
    return {
      dataInterval: null, 
      selectScenicAreaId: -1,
    
      centerPeopleFlowData: {},
      centerPeopleFlow:[
        {name: '進場人數', countKey: CONST.CENTER_PEOPLE_FLOW_API_KEY.PEOPLE_COME_IN},
        {name: '離場人數', countKey: CONST.CENTER_PEOPLE_FLOW_API_KEY.PEOPLE_COME_OUT},
        {name: '在園人數', countKey: CONST.CENTER_PEOPLE_FLOW_API_KEY.PEOPLE_INSITE},
      ],

      peopleAnalysisData: {},
      genderCategory: [
        {name: '男性', countKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.MAN_COUNT, ratioKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.MAN_RATIO}, 
        {name: '女性', countKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.WOMAN_COUNT, ratioKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.WOMAN_RATIO}, 
      ],
      ageCategory: [
        {name: CONST.AGE.AGE_0_11, ageKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_0_11, ratioKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_0_11_RATIO,}, 
        {name: CONST.AGE.AGE_12_19, ageKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_12_19, ratioKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_12_19_RATIO}, 
        {name: CONST.AGE.AGE_20_29, ageKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_20_29, ratioKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_20_29_RATIO},
        {name: CONST.AGE.AGE_30_39, ageKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_30_39, ratioKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_30_39_RATIO}, 
        {name: CONST.AGE.AGE_40_49, ageKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_40_49, ratioKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_40_49_RATIO}, 
        {name: CONST.AGE.AGE_50_59, ageKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_50_59, ratioKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_50_59_RATIO},
        {name: CONST.AGE.AGE_60_ABOVE, ageKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_60_ABOVE, ratioKey: CONST.PEOPLE_ATTRIBUTE_API_KEY.AGE_60_ABOVE_RATIO}
      ]
    };
  },
  computed: { 
    ...mapState('scenicArea', {scenicAreaList: 'allscenicArea'}),

    peopleAnalysisScenicArea() {
      return this.scenicAreaList.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.PEOPLE_ANALYZE))
    },
  },
  watch: {

  },
  methods: {
    async getAllData() {
      await this.$store.dispatch('peopleAttribute/getPeopleAttributeList', this.selectScenicAreaId === -1 ? {} : {scenicAreaId: this.selectScenicAreaId})
      await this.$store.dispatch('centerPeopleFlow/getCenterPeopleFlowList', this.selectScenicAreaId === -1 ? {} : {scenicAreaId: this.selectScenicAreaId})
      this.peopleAnalysisData = this.$store.getters['peopleAttribute/getCenterOverViewData'](this.selectScenicAreaId)
      this.centerPeopleFlowData = this.$store.getters['centerPeopleFlow/getCenterOverViewData'](this.selectScenicAreaId)
    },
  },
  async mounted() {
    this.getAllData()
    this.dataInterval = setInterval(async () => {
      // this.getAllData()
    }, CONST.REFRESH_DAT_TIMER_MIN)

    
  },
  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval)
    this.dataInterval = null
  }
};
</script>
